import { render } from "./usersettings.vue?vue&type=template&id=129400d0"
import script from "./usersettings.vue?vue&type=script&lang=js"
export * from "./usersettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__